// 错误日志工具
export const ErrorLogger = {
  // 查看所有错误
  getAllErrors() {
    const errors = {
      vue: JSON.parse(localStorage.getItem('vueErrors') || '[]'),
      js: JSON.parse(localStorage.getItem('jsErrors') || '[]'),
      promise: JSON.parse(localStorage.getItem('promiseErrors') || '[]'),
      router: JSON.parse(localStorage.getItem('routerErrors') || '[]'),
      component: JSON.parse(localStorage.getItem('componentErrors') || '[]')
    };
    
    console.log('=== 所有错误日志 ===');
    console.log('Vue Errors:', errors.vue);
    console.log('JavaScript Errors:', errors.js);
    console.log('Promise Errors:', errors.promise);
    console.log('Router Errors:', errors.router);
    console.log('Component Errors:', errors.component);
    
    return errors;
  },
  
  // 清除所有错误日志
  clearAllErrors() {
    localStorage.removeItem('vueErrors');
    localStorage.removeItem('jsErrors');
    localStorage.removeItem('promiseErrors');
    localStorage.removeItem('routerErrors');
    localStorage.removeItem('componentErrors');
    console.log('所有错误日志已清除');
  },
  
  // 显示最近的错误
  showRecentErrors(count = 5) {
    const errors = this.getAllErrors();
    const allErrors = [];
    
    Object.keys(errors).forEach(type => {
      errors[type].forEach(error => {
        allErrors.push({ ...error, type });
      });
    });
    
    // 按时间排序
    allErrors.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
    
    console.log(`=== 最近 ${count} 个错误 ===`);
    allErrors.slice(0, count).forEach((error, index) => {
      console.log(`${index + 1}. [${error.type}] ${error.timestamp}`);
      console.log(`   错误: ${error.error || error.message || error.reason}`);
      if (error.stack) {
        console.log(`   堆栈: ${error.stack}`);
      }
      console.log('---');
    });
  }
};

// 在控制台中暴露错误查看工具
window.ErrorLogger = ErrorLogger; 